// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    purchase: true,
    refund: true,
    recurringContribution: true,
    additionalContribution: true,
    changeProduct: true,
    cancelService: true,
    isFetching: false,
    isFeatureModalOpen: false,
    error: false,
    zeroCommision: false,
    hireWithTransfer: false,
});

const RAFeatureFlag = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_FEATURE_FLAG_REQUEST:
            return state.merge({
                isFetching: true,
                error: false,
                isFeatureModalOpen: false,
            });
        case actionTypes.RA_FEATURE_FLAG_FAILURE:
            return state.merge({
                isFetching: false,
                error: true,
                isFeatureModalOpen: false,
            });
        case actionTypes.RA_FEATURE_FLAG_MODAL_TOGGLE:
            return state.merge({
                isFeatureModalOpen: !state.get('isFeatureModalOpen'),
                purchase: !state.get('purchase'),
            });
        case actionTypes.RA_FEATURE_FLAG_SUCCESS:
            return state.mergeDeep({
                isFetching: false,
                error: null,
                purchase: action.payload.data.hiring === 'true',
                refund: action.payload.data.withdrawal === 'true',
                recurringContribution:
                    action.payload.data['recurring-subscription'] === 'true',
                additionalContribution:
                    action.payload.data['additional-subscription'] === 'true',
                changeProduct: action.payload.data['product-change'] === 'true',
                cancelService:
                    action.payload.data['cancel-portfolio'] === 'true',
                zeroCommision:
                    action.payload.data['zero-commissions-enable'] === 'true',
                hireWithTransfer:
                    action.payload.data['hire-with-transfer'] === 'true',
            });
        default:
            return state;
    }
};

module.exports = RAFeatureFlag;
